var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blumar-alert"},[_c('b-alert',{attrs:{"show":_vm.show,"variant":_vm.alertStyle,"dismissible":"","fade":""},on:{"dismissed":function($event){return _vm.hide()}}},[_vm._v(_vm._s(_vm.alertText))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4380f52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BlumarAlert.vue
// module id = 835
// module chunks = 0